/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckRevertMovedOutEligibility200ResponseData
 */
export interface CheckRevertMovedOutEligibility200ResponseData {
    /**
     * Whether the lead can be reverted to moved-in status
     * @type {boolean}
     * @memberof CheckRevertMovedOutEligibility200ResponseData
     */
    can_revert?: boolean;
    /**
     * Name of the previous bed (only present if can_revert is false)
     * @type {string}
     * @memberof CheckRevertMovedOutEligibility200ResponseData
     */
    previous_bed_name?: string;
}

/**
 * Check if a given object implements the CheckRevertMovedOutEligibility200ResponseData interface.
 */
export function instanceOfCheckRevertMovedOutEligibility200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckRevertMovedOutEligibility200ResponseDataFromJSON(json: any): CheckRevertMovedOutEligibility200ResponseData {
    return CheckRevertMovedOutEligibility200ResponseDataFromJSONTyped(json, false);
}

export function CheckRevertMovedOutEligibility200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRevertMovedOutEligibility200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'can_revert': !exists(json, 'can_revert') ? undefined : json['can_revert'],
        'previous_bed_name': !exists(json, 'previous_bed_name') ? undefined : json['previous_bed_name'],
    };
}

export function CheckRevertMovedOutEligibility200ResponseDataToJSON(value?: CheckRevertMovedOutEligibility200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'can_revert': value.can_revert,
        'previous_bed_name': value.previous_bed_name,
    };
}

